function quantity(){
  $(document).on('click', '.qty-wrapper span', function() {
    const $this = $(this);
    let qtyInput = $this.parent().find('input');
    let qtyInputVal = qtyInput.val();
    qtyInputVal = ($.isNumeric(qtyInputVal)) ? qtyInputVal : 0;

    if ($this.hasClass('qty-plus')) {
      qtyInputVal++;
      qtyInputVal = (qtyInputVal < 0) ? 1 : qtyInputVal;
    }else{
      qtyInputVal--;
      qtyInputVal = (qtyInputVal < 0) ? 0 : qtyInputVal;
    }
    qtyInput.val(qtyInputVal)
    qtyInput.trigger('change');
  })

}

export default quantity();



// WEBPACK FOOTER //
// ../markup/assets/js/quantity.js